import { getAccessToken } from '@blaze-cms/core-auth-ui';
const hasAuthCookie = ({
  req
}) => {
  if (!req) return false;
  return !!getAccessToken(req.headers.cookie);
};
export default hasAuthCookie;
//# sourceMappingURL=has-auth-cookie.js.map